module.exports = __webpack_public_path__ + "img/tutorial_library_01.2d75bc11.png";